$(document).on('click', '.js-btn-product-ajax', function (event) {
  event.preventDefault();

  const $this = $(this);
  const $form = $this.closest('form');

  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: $form.serialize(),
  })
    .done(function () {
      $.ajax({
        url: '/cart',
        success: function (response) {
          const $result = $(response).find('.js-mini-cart form');
          const counter = $(response).find('.js-cart-bag').html();

          $('.js-mini-cart').find('form').empty().remove();
          $('.js-mini-cart-content').append($result);

          if (counter === undefined) {
            $('.js-cart-bag').remove();
          } else {
            $('.js-cart-bag').html(counter);
          }

          $('body').addClass('show-mini-cart');
        },
      });
    })
    .fail(function (error) {
      alert(error.responseJSON.description);
    });
});
